import React, { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Torpedo from '@wix/da-shared-react/pkg/Torpedo/DeviationTorpedo';
import Grid from '@wix/da-shared-react/pkg/Grid/DeviationGrid';
import LoadableDuperbrowseContext from '../../../../contexts/LoadableDuperbrowseContext';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { PapiDeviation } from '@wix/da-papi-types';
import { GallectionType } from '../../../../../types/gallection';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import MobileGridDynamic300x250 from '@wix/da-ads/pkg/adunits/anon/MobileGridDynamic300x250';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '@wix/da-shared-react/pkg/Ads/redux/selectors';
// import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';

import s from './GallectionDeviationsTorpedo.scss';

export interface Props {
  streamId: string;
  gallectionType: GallectionType;
  deviations: PapiDeviation[];
}

const TORPEDO_DEFAULT_SIZE = {
  desktop: { width: 1024, height: 0 },
  mobile: { width: 320, height: 0 },
};
const TORPEDO_CONTAINER_SIZE = { width: 1024 };

export const GallectionDeviationsTorpedo: React.FC<Props> = ({
  streamId,
  deviations,
  gallectionType,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { adsEnabled } = useContext(SessionContext);
  const adSafety = useSelector(state => getCurrentAdSafety(state));
  // const isNsfgFallback = useFlag('ads_dealer_nsfg');
  const adAfter = undefined; // (adSafety !== 'off' || isNsfgFallback) && adsEnabled ? 10 : undefined;
  const renderAd = useCallback(
    (rowId: number) => {
      if (!isMobile || !adsEnabled) {
        return null;
      }
      return (
        <div className={s['ad']}>
          <MobileGridDynamic300x250 rowId={rowId} safety={adSafety!} />
        </div>
      );
    },
    [adSafety, adsEnabled, isMobile]
  );

  return (
    <LoadableDuperbrowseContext
      streamId={streamId}
      parent={{
        title: t(
          gallectionType === GallectionType.GALLERY
            ? 'duperbrowse.backButton.profile.gallery'
            : 'duperbrowse.backButton.profile.favourites'
        ),
      }}
    >
      <BiLoggerContextProvider value={{ widgetname: 'folder_deviations' }}>
        {isMobile ? (
          <Grid
            items={deviations}
            cookieType={MeasuredCookieType.USER_PROFILE_GALLECTION_CONTENT}
            spacing={8}
            enableScrollOptim
            allowMobileCard
            adAfterNRow={adAfter}
            adRenderer={adAfter && renderAd}
          />
        ) : (
          <Torpedo
            cookieType={MeasuredCookieType.USER_PROFILE_GALLECTION_CONTENT}
            cookieDim={'width'}
            defaultSize={TORPEDO_DEFAULT_SIZE}
            container={TORPEDO_CONTAINER_SIZE}
            items={deviations}
            enableScrollVisibilityOptimisation
          />
        )}
      </BiLoggerContextProvider>
    </LoadableDuperbrowseContext>
  );
};
GallectionDeviationsTorpedo.displayName = 'GallectionDeviationsTorpedo';

export default GallectionDeviationsTorpedo;
